export const BOOKING_DATA = 'bookingData';
export const SELECTED_APPOINTMENT_DATA = 'selectedAppointmentData';
